<template>
  <router-link
    :id="'nav-item-' + name"
    :data-testid="`document-nav-item-${name}`"
    class="document-panel-nav-item d-flex flex-row justify-content-center align-items-center i-px-8 i-py-6"
    :to="link"
  >
    <i-icon :symbol="icon" :size="16" class="icon"></i-icon>
    <i-tooltip
      v-if="tooltip"
      :target="'#nav-item-' + name"
      :title="tooltip"
      :alignment="
        isLast
          ? iTooltipAlignmentMode.BOTTOM_RIGHT
          : iTooltipAlignmentMode.BOTTOM_MIDDLE
      "
    ></i-tooltip>
  </router-link>
</template>

<script>
import { iIcon, iTooltip, iTooltipAlignmentMode } from '@inscribe/signal';

export default {
  components: { iIcon, iTooltip },
  props: {
    name: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      default: null,
    },
    link: {
      type: String,
      default: null,
    },
    isLast: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    iTooltipAlignmentMode,
  }),
};
</script>

<style scoped lang="scss">
.document-panel-nav-item {
  color: $light-neutral-110;
  background: $light-neutral-30;
  font-size: $font-size-secondary;
  width: 100%;

  .icon {
    color: $light-neutral-110 !important;
  }

  &:hover {
    background-color: $light-neutral-20;
  }

  &.router-link-active {
    background: $white-base;

    .icon {
      color: $light-primary-110 !important;
    }
  }
}
</style>
